import React, { useEffect } from "react";
import "./GlitchTheme.css";
import GalaxyBackground from "./GalaxyBackground";

const socials = [
  {
    name: "INSTAGRAM",
    url: "https://instagram.com/edu.bertozzi",
    delay: "0.15s",
  },
  {
    name: "SPOTIFY",
    url: "https://open.spotify.com/intl-pt/artist/2D0e0cN9KP1b2q2QddZ5ZM?si=z8hZ9INRS_C4wTvVT4MqJw",
    delay: "0.25s",
  },
  {
    name: "APPLE MUSIC",
    url: "https://music.apple.com/br/artist/eduardo-bertozzi/1783264354",
    delay: "0.45s",
  },
];

const Contato: React.FC = () => {
  // Spotlight segue o mouse
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      document.documentElement.style.setProperty(
        "--mouse-x",
        `${(e.clientX / window.innerWidth) * 100}%`
      );
      document.documentElement.style.setProperty(
        "--mouse-y",
        `${(e.clientY / window.innerHeight) * 100}%`
      );
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div className="wonder-page wonder-galaxy galaxy-subpage">
      <GalaxyBackground />

      <div className="galaxy-subpage-content contato-page">
        {/* ── HEADER ──────────────────────────────────────── */}
        <header className="glitch-wrapper contato-header">
          <h1 className="glitch-title galaxy-title-text" data-text="CONTATO">
            CONTATO
          </h1>
          <p className="contato-subtitle galaxy-subtitle blur-text-reveal">
            SHOWS & INFORMAÇÕES // CONEXÃO DE SISTEMA
          </p>
        </header>

        <div className="contato-body">
          {/* ── EMAIL TERMINAL BOX ──────────────────────── */}
          <div className="contato-email-card galaxy-card card-hover">
            <div className="contato-terminal-bar galaxy-terminal-bar">
              <span className="galaxy-accent">&gt;</span>{" "}
              INICIAR_PROTOCOLO_DE_MENSAGEM
            </div>
            <p className="contato-email-text galaxy-body-text">
              Para propostas de shows, parcerias, imprensa ou outras
              solicitações, inicie a conexão direta através do servidor de
              e-mail seguro.
            </p>
            <a
              href="mailto:bertozzidudu@gmail.com"
              className="wonder-galaxy-btn contato-email-btn"
            >
              <span>ENVIAR E-MAIL</span>
            </a>
          </div>

          {/* ── SOCIALS GRID ────────────────────────────── */}
          <div className="contato-socials">
            {socials.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noreferrer"
                className="social-btn galaxy-social-btn"
                style={{ animationDelay: social.delay }}
              >
                [ {social.name} ]
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contato;
